import { Model } from '@adobe/aem-spa-page-model-manager';
import { Marker } from '../../assembler-server/types/Marker';

export const find = <T extends Model>(model: Model, isMatch: (model: T) => boolean, callback: (model: T) => void): void => {
  if (isMatch(model as T)) {
    callback(model as T);
  }

  const values = Object.values(model);
  for (const value of values) {
    if (value && typeof value === 'object') {
      find(value, isMatch, callback);
    }
  }
};

export const getId = (model: Marker) => `${model.markerScope}_${model.version}`;
